module.exports = __webpack_public_path__ + "static/art_start-44ad521a994f62201f7d5c196e895a48.png";